module.exports = __webpack_public_path__ + "img/Eridanus.a6e29133.png";